import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { bootstrapParentAuth } from "@/lib/parentAuth";

// Bootstrap parent-app authentication BEFORE React renders so:
//  - the URL `?token=...` query param is stripped before any component
//    sees it (otherwise React Router's location is "polluted" briefly),
//  - the global fetch interceptor is in place by the time the first
//    /api/* call fires from a useEffect, and
//  - any auth-aware UI (e.g. a future "Signed in as" pill in the header)
//    can read the claims off sessionStorage on first paint.
//
// Failure-tolerant: bootstrapParentAuth never throws; if exchange fails
// or there's no token, we fall through and render anonymously.
bootstrapParentAuth().finally(() => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});

// Register the offline service worker. Skip on localhost dev servers
// (CRA's HMR and SW caching don't play nicely in development).
if ("serviceWorker" in navigator && window.location.hostname !== "localhost") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* SW registration failed — app still works online */
    });
  });
}
